import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { SuspenseBoundary } from '@/components/SuspenseBoundary';
import { AvailableReportCard } from '@/components/widgets/o/ReportCard/AvailableReportCard';
import { Report, ReportCard } from '@/components/widgets/o/ReportCard/ReportCard';
import { useAvailableAutomatedReports } from '@/pages/shared/hooks/useReports';

type ReportsListProps = {
  reports: Report[];
  onDownload?: (report: Report) => void;
  onClick?: (report: Report) => void;
  totalReports?: number;
};

export const ReportsList = ({ reports, onClick, onDownload, totalReports }: ReportsListProps) => {
  const { t } = useTranslation();
  const { data: availableReports } = useAvailableAutomatedReports();

  const availableReportTypes = availableReports?.results.map((r) => r.report_type) ?? [];

  const nonGeneratedReports = availableReportTypes.filter(
    (type) => !reports.some((report) => report.report_type === type),
  );

  return (
    <SuspenseBoundary>
      <Stack data-testid='reports-section'>
        <Stack direction='row' className='w-full justify-between'>
          {reports.length > 0 && (
            <span className='typography-body2 font-medium text-text-primary uppercase'>
              {t('reports.count', { count: totalReports })}
            </span>
          )}
        </Stack>
        <Stack direction='row' spacing={6} className='flex-wrap w-full py-5'>
          {reports.map((report) => (
            <div key={report.id}>
              <ReportCard report={report} onDownload={onDownload} onClick={onClick} />
            </div>
          ))}
          {nonGeneratedReports.map((report) => (
            <div key={report}>
              <AvailableReportCard report={report} />
            </div>
          ))}
        </Stack>
      </Stack>
    </SuspenseBoundary>
  );
};
